import some from 'lodash/some';
import castArray from 'lodash/castArray';

export const hasFeatures = (agencyFeatures, featuresToFind) =>
  some(castArray(agencyFeatures), feature =>
    castArray(featuresToFind).includes(feature)
  );

export const FEATURES = {
  userTrainingSection: 'userTrainingSection::1.0',
  userMergeTrainingSection: 'userMergeTrainingSection::1.0',
  userTrainingSectionHyperlinks: 'userTrainingSectionHyperlinks::1.0',
  userEquipmentSection: 'userEquipmentSection::1.0',
  enableCaseFileTaskListPanel: 'enableCasefileTaskListPanel::1.0',
  enableContributeToReport: 'enableContributeToReport::1.0',
  addressVerification: 'addressVerification::1.0',
  enableCasefileKeyDetails: 'enableCasefileKeyDetails::1.0',
  enableReportsTable: 'enableReportsTable::1.0',
  enableNestedRepeaterConditional: 'enableNestedRepeaterConditional::1.0',
  dataExportReportPrinting: 'dataExportReportPrinting::1.0',
  enableBulkReportPrinting: 'enableBulkReportPrinting::1.0',
  disableLegacyPrint: 'disableLegacyPrint::1.0',
  userSupervisorHistorySection: 'userSupervisorHistorySection::1.0',
  userAssignmentHistorySection: 'userAssignmentHistorySection::1.0',
  exportDraftReport: 'exportDraftReport::1.0',
};
